<template>
  <svg
    width="119"
    height="73"
    viewBox="0 0 119 73"
    fill="none"
    aria-hidden="true"
    :style="{color}"
  >
    <path
      d="M7.53313 7.39822L1.16327 38.5292C0.271113 42.8893 3.10889 47.1394 7.47801 47.9866L23.6098 51.1146L98.771 71.3639C103.042 72.5144 107.435 69.9815 108.58 65.7093L117.317 33.0915C118.519 28.6028 115.657 24.0376 111.093 23.1641L86.451 18.4479L34.9747 5.11489L17.0861 1.18797C12.7269 0.231056 8.42777 3.02589 7.53313 7.39822Z"
      fill="currentColor"
      fill-opacity="0.4"
      stroke="currentColor"
      stroke-width="2"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
/**
 * Контур парковки в мобильном превью. Цвет наследуют заливка и обводка.
 */
export default {
  name: "ParkingMapPolygon",
  props: {
    color: {
      type: String,
      default: "#34C759",
    },
  },
};
</script>
